import { c, IllustrationFrame, sc, type IllustrationProps } from './Illustration';

/** Ideas empty state. A bright idea with a little gift inside. */
export function Lightbulb(props: IllustrationProps) {
  return (
    <IllustrationFrame {...props}>
      <ellipse cx="80" cy="144" rx="30" ry="5" style={{ fill: sc('border.default') }} />
      <path
        d="M80 22c-24 0-42 18-42 41 0 16 9 26 17 34 4 4 6 9 6 14v6h38v-6c0-5 2-10 6-14 8-8 17-18 17-34 0-23-18-41-42-41z"
        style={{ fill: c('gold.300') }}
      />
      <path
        d="M62 60c0-10 8-18 18-18"
        style={{
          fill: 'none',
          stroke: c('neutral.0'),
          strokeWidth: 5,
          strokeLinecap: 'round',
          opacity: 0.7,
        }}
      />
      <rect x="61" y="117" width="38" height="8" rx="4" style={{ fill: c('neutral.400') }} />
      <rect x="64" y="127" width="32" height="8" rx="4" style={{ fill: c('neutral.500') }} />
      <rect x="68" y="70" width="24" height="18" rx="3" style={{ fill: c('berry.400') }} />
      <rect x="77" y="70" width="6" height="18" style={{ fill: c('blue.500') }} />
      <path
        d="M80 70c-3-7-11-7-10-2s7 2 10 2zm0 0c3-7 11-7 10-2s-7 2-10 2z"
        style={{ fill: c('blue.500') }}
      />
      <path
        d="M26 44l-10-4M134 44l10-4M80 10V2M36 22l-7-7M124 22l7-7"
        style={{ stroke: c('gold.500'), strokeWidth: 4, strokeLinecap: 'round' }}
      />
    </IllustrationFrame>
  );
}
